import { LLWildSymbolResult } from "integration/builders/result/ll-wild-bonus-result-builder";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";
import Sequence from "slotworks/utils/contracts/sequence";
import Timer from "slotworks/utils/timer";
import gameState from "slotworks/model/game-state";
import GatewayResult from "model/gameplay/records/results/gateway-result";

export default class LLFortuneBlastWildCelebration extends State {

    public onEnter() {

        const record = GameState.getCurrentGame().getCurrentRecord();
        const wildBonusResult = record.getResultsOfType(LLWildSymbolResult)[0];

        this.playCelebration(wildBonusResult).then(() => {
            Components.matrix.resetSymbols();
            this.complete();
        });
    }

    protected playCelebration(wildBonusResult: SymbolWinResult) {

        const winningSymbols = this.getSymbolsById("WW_BN");
        const self = this;

        return new Sequence([
            () => new Parallel([
                () => Components.footer.showCustomResult(wildBonusResult, "wild_fortune_blast_win", {}),
                () => new Parallel(winningSymbols.map((symbol) => () => symbol.highlight()))
            ]),
            () => new Parallel([
                () => new Parallel(winningSymbols.map((symbol) => () => symbol.land())),
                () => Contract.wrap(() => Services.sound.event(SoundEvent.symbol_ID_highlight, "WW_BN"))
            ]),
            () => new Parallel([
                () => Contract.wrap(() => winningSymbols.forEach((symbol) => symbol.win().then( () => symbol.static()))),
                () => Contract.wrap(() => Services.sound.customEvent("fortune_blast_ww"))
            ]),
            () => Contract.wrap(() => Services.sound.customEvent("ww")),
            () => Contract.getTimeoutContract(1600),
            () => this.playBellSound()
        ]);
    }

    protected playBellSound() {
        const doubleBonus = gameState.getCurrentGame().getCurrentRecord().getResultsOfType(GatewayResult).length > 0;

        if (doubleBonus) {
            return Contract.empty();
        } else {
            return Services.sound.customEventContract("bonus_bell");
        }
    }

    protected getSymbolsById(symbolId: string) {
        return Components.matrix.getGridSymbols().filter((symbol) => {
            return symbol.symbolId === symbolId;
        });
    }
}
